import { MessageSquare, FileCheck, PenTool, CheckSquare } from "lucide-react";

const Process = () => {
  const steps = [
    {
      icon: MessageSquare,
      step: "01",
      title: "Initial Consultation",
      description: "Share your property registration requirements with our experts. We'll assess your needs and provide a clear roadmap.",
      color: "from-blue-500 to-blue-600"
    },
    {
      icon: FileCheck,
      step: "02",
      title: "Document Verification",
      description: "Our team thoroughly verifies all property documents, ensuring authenticity and legal compliance.",
      color: "from-emerald-500 to-emerald-600"
    },
    {
      icon: PenTool,
      step: "03",
      title: "Drafting & Legal Review",
      description: "Professional drafting of sale deeds and agreements, followed by comprehensive legal review.",
      color: "from-amber-500 to-amber-600"
    },
    {
      icon: CheckSquare,
      step: "04",
      title: "Registration Completion",
      description: "We coordinate with the sub-registrar office and ensure smooth registration with all formalities completed.",
      color: "from-purple-500 to-purple-600"
    }
  ];

  return (
    <section id="process" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-blue-50 rounded-full px-6 py-2 mb-6">
            <span className="text-blue-700 font-semibold text-sm tracking-wide">OUR PROCESS</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Simple 4-Step Registration Process
          </h2>
          
          <p className="text-lg text-slate-600">
            We've streamlined the property registration process to make it hassle-free and transparent for you.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-blue-200 via-emerald-200 via-amber-200 to-purple-200 z-0" style={{ width: '85%', left: '7.5%' }}></div>

          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative z-10"
            >
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-slate-100 h-full">
                {/* Step number */}
                <div className={`inline-block bg-gradient-to-br ${step.color} text-white text-sm font-bold px-4 py-2 rounded-full mb-6`}>
                  STEP {step.step}
                </div>

                {/* Icon */}
                <div className={`bg-gradient-to-br ${step.color} rounded-xl p-4 inline-block mb-6`}>
                  <step.icon className="text-white" size={32} />
                </div>
                
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  {step.title}
                </h3>
                
                <p className="text-slate-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center bg-gradient-to-r from-slate-800 to-slate-700 rounded-2xl p-12">
          <h3 className="text-3xl font-bold text-white mb-4">
            Start Your Property Registration Today
          </h3>
          <p className="text-gray-200 mb-8 max-w-2xl mx-auto">
            Get in touch with our experts for a free consultation and experience hassle-free property registration.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="tel:+918217026707"
              className="bg-emerald-600 text-white px-8 py-4 rounded-lg font-bold hover:bg-emerald-700 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Call Now
            </a>
            <a 
              href="https://wa.me/918217026707"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-slate-800 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
